import type { Router } from 'vue-router'
import i18n from '@/locales'
import { nextTick } from 'vue'
import { taAutoTrackSinglePage, track } from '@/utils/tracking'
import { useAppDetection } from '@/composables/useAppDetection'

/**
 * 设置页面标题
 */
export function setPageTitle(to: any): void {
  if (to.meta.titleKey) {
    try {
      const title = i18n.global.t(to.meta.titleKey)
      document.title = title || import.meta.env.VITE_APP_TITLE
    } catch (error) {
      console.warn('获取路由标题失败:', error)
      document.title = import.meta.env.VITE_APP_TITLE
    }
  } else {
    document.title = import.meta.env.VITE_APP_TITLE
  }
}

/**
 * 权限检查
 */
export function checkAuth(to: any, from: any, next: any): void {
  // 这里可以添加权限检查逻辑
  // 例如：检查用户是否登录、是否有访问权限等
  
  // 示例：检查是否需要登录
  if (to.meta.requiresAuth && !isAuthenticated()) {
    next('/login')
    return
  }
  
  next()
}

/**
 * 检查用户是否已认证
 */
function isAuthenticated(): boolean {
  // 实现认证检查逻辑
  // 例如：检查localStorage中的token
  return !!localStorage.getItem('token')
}

/**
 * 获取页面标题
 */
function getPageTitle(route: any): string {
  if (route.meta.titleKey) {
    try {
      return i18n.global.t(route.meta.titleKey) || import.meta.env.VITE_APP_TITLE
    } catch (error) {
      console.warn('获取路由标题失败:', error)
      return import.meta.env.VITE_APP_TITLE
    }
  }
  return import.meta.env.VITE_APP_TITLE
}

/**
 * 检测应用是否安装
 */
let appDetection: any = null
function getAppInstallStatus(): boolean {
  if (!appDetection) {
    appDetection = useAppDetection({
      scheme: 'jihuanshe://',
      universalLink: 'https://jihuanshe.com/app',
      timeout: 2000
    })
  }
  return appDetection.isInstalled.value === true
}

/**
 * 页面访问统计
 */
export function trackPageView(to: any): void {
  nextTick(() => {
    taAutoTrackSinglePage();
    
    // 上报访问H5链接埋点
    const linkAddress = window.location.href
    const linkTitle = getPageTitle(to)
    const isJhsInstalled = getAppInstallStatus()
    
    track('visit_h5_link', {
      link_address: linkAddress,
      link_title: linkTitle,
      // is_jhs_installed: isJhsInstalled  // 暂时获取不到安装状态，暂不上报
    })
  });
}

/**
 * 设置路由守卫
 */
export function setupRouterGuards(router: Router): void {
  // 全局前置守卫
  router.beforeEach((to, from, next) => {
    // 设置页面标题
    setPageTitle(to)
    
    // 权限检查
    checkAuth(to, from, next)
  })

  // 全局后置守卫
  router.afterEach((to, from) => {
    // 页面访问统计
    trackPageView(to)
  })
} 